<template>
  <tr>
    <td>{{user.firstName}}</td>
    <td>{{user.lastName}}</td>
    <td>{{user.email}}</td>
    <td>${{payoutValue}}</td>
    <td>
      <span
        v-if="user.hasFiledTaxForm"
        class="text-success"
      >
        FILED
      </span>

      <span
        v-else
        class="text-danger"
      >
        NOT FILED
      </span>
    </td>
    <td>
      <BasicButton
        v-if="user.hasFiledTaxForm"
        class="btn btn-link p-0"
        :isProcessing="isProcessing"
        @click="() => toggleHasFiledTaxForm(false)"
      >
        Mark as not filed
      </BasicButton>

      <BasicButton
        v-else
        class="btn-link p-0"
        :isProcessing="isProcessing"
        @click="() => toggleHasFiledTaxForm(true)"
      >
        Mark as filed
      </BasicButton>

      <span
        v-if="getRequestError()"
        class="text-danger"
      >
        {{getRequestError()}}
      </span>
    </td>
  </tr>
</template>

<script>
  import get from 'lodash/get'

  import AdminAPI from '@/api/AdminAPI'

  import RequestMixin from '@/mixins/RequestMixin'

  import BasicButton from '@/components/BasicButton'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      BasicButton,
    },

    props: {
      user: {
        type: Object,
        required: true,
      },
      year: {
        type: Number,
        required: true,
      },
    },

    computed: {
      payoutValue() {
        return get(this.user, ['payouts', this.year], 0)
      },
    },

    methods: {
      async toggleHasFiledTaxForm(flag) {
        await this.handleRequest(async () => {
          const user = await AdminAPI.updateUsersHasFiledTaxForm(this.user.id, flag)

          this.$emit('userUpdated', user)
        })
      },
    },
  }
</script>

<style lang="scss">

</style>
